import { UserDto } from '@marketplace-web/shared/user-data'
import { SellerBadgeDto } from '@marketplace-web/seller-engagement-tools/seller-engagement-tools-data'
import { ItemDetailsSidebarSectionResp } from '@marketplace-web/domain/item-page-data'

import { ItemPageUserInfoSellerBadgesPluginDto } from './types'

export const getItemPageUserInfoSellerBadgesPluginDto = (itemDto: {
  user: UserDto & { seller_badges?: Array<Omit<SellerBadgeDto, 'progress'>> }
}): ItemPageUserInfoSellerBadgesPluginDto => ({
  seller_badges: itemDto.user.seller_badges,
})

export const getServerItemPageUserInfoSellerBadgesPluginDto = (
  sidebarDto: ItemDetailsSidebarSectionResp,
): ItemPageUserInfoSellerBadgesPluginDto => ({
  seller_badges: sidebarDto.seller_badges,
})
